export var EventEditor = {
  name: "edit",
  component: "EditPanel",
  layout: "edit-base",
  mode: "visible",
  showOn: true,
};
